import { memo } from 'react';

export type WorkspaceAgentDefinitionRowProps = {
  'data-testid'?: string;
  label: string;
  value: string;
};

/**
 * One label/value pair from a clip's metadata.
 *
 * Renders `dt`/`dd` and so must sit inside a `<dl>` — `WorkspaceAgentDefinitionList` is the usual
 * owner.
 */
export const WorkspaceAgentDefinitionRow = memo(
  ({ 'data-testid': testId, label, value }: WorkspaceAgentDefinitionRowProps) => (
    <div className="flex items-start justify-between gap-3" data-testid={testId}>
      <dt className="shrink-0 ads:text-metadata text-12 text-gray-9 leading-4">{label}</dt>
      <dd className="min-w-0 break-words text-right ads:text-metadata text-12 text-gray-10 leading-4">{value}</dd>
    </div>
  ),
);

WorkspaceAgentDefinitionRow.displayName = 'WorkspaceAgentDefinitionRow';
